<template>
  <div class="box">
    <div @click="toHighEndTradeRule({ fundCode, fundName })" class="row">
      <div class="tip">
        <div :fontZoomScale="1.0" class="text1 text">{{ `购买费率:`}}</div>
        <div class="text3 text" :fontZoomScale="1.0">{{ rateInfo.rate }}</div>
        <img class="right-arrow" src="https://j5.dfcfw.com/sc/image/202305/20230529052234.png" />
      </div>
      <div
        v-if="btnConfig.length === 2 && btnConfig[1].tipText"
        @click="toHighEndTradeRule({ fundCode, fundName })"
        :fontZoomScale="1.0"
        class="text1 text"
        >{{ btnConfig[1].tipText }}</div
      >
    </div>
    <div class="btns">
      <!-- 讨论 -->
      <div @click="clickDiscuss" class="img1">
        <img class="img" src="https://j5.dfcfw.com/imagesystem/material_imgs/1741228325838476.png" />
        <div class="icon-text">讨论</div>
        <div v-if="isShowRedPoint" class="red-point" />
      </div>

      <div class="right" :style="{ width: btnConfig.length === 2 ? 400 : 330 }">
        <!-- 购买 -->
        <div
          v-if="btnConfig.length === 1"
          class="big-btn"
          :style="{
            backgroundImage: `url(${btnConfig[0].img})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }"
          @click="clickBuy(btnConfig[0])"
        >
          <!-- <img class="btn-big-img" :src="btnConfig[0].img" /> -->
          <div class="buy-text">{{
            btnConfig[0].text
          }}</div>
          <div v-if="seatDesc" class="btn-desc-text">{{ seatDesc }}</div>
        </div>
        <div v-if="btnConfig.length === 2" class="two-btns">
          <div
          @click="clickBuy(btnConfig[0])"
          class="left-btn"
          :style="{
            backgroundImage: `url(${btnConfig[0].img})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }"
          >
            <p class="btn-text">{{ btnConfig[0].text }}</p>
            <p v-if="btnConfig[0].btnBottomText" class="btn-desc-text">{{
              btnConfig[0].btnBottomText
            }}</p>
          </div>
          <div
          @click="clickBuy(btnConfig[1])"
          class="right-btn"
          :style="{
            backgroundImage: `url(${btnConfig[1].img})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }"
          >
            <p class="btn-text">{{ btnConfig[1].text }}</p>
            <p v-if="btnConfig[1].btnBottomText" class="btn-desc-text">{{
              btnConfig[1].btnBottomText
            }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInvestorAuditResult } from '@/apis/IbgApi';
import tool from '@/utils/tool';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import dayjs from 'dayjs';

export default {
  name: 'HighEndFixBottomBtn',

  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 基金详情数据
    mergeData: Object,
    productSeatsInfo: Object, // 产品席位信息
    productAlternateInfo: {
      // 产品候补计划候补信息
      default: () => {},
      type: Object,
    },
  },

  data: () => ({
    isSelected: false, // 基金自选状态
    isSetRemind: false, // 设置提醒状态
    riskInfo: {}, // 风险测评信息
    auditAndSignInfo: {}, // 审核签约信息
    isShowRedPoint: false, // 是否显示红点
    flag: false, // 是否已经初始化购买状态
  }),

  computed: {
    isAndroid() {
      return multi.$system.isAndroid;
    },

    // 基金名称
    fundName() {
      const { elementData } = this;
      console.log('tradeData>>>', elementData);
      return elementData?.fundName || '--';
    },

    // 固底费率信息
    rateInfo() {
      const { mergeData } = this;
      const fixedBottomBtnInfo = mergeData?.fixedBottomBtnInfo || {};
      return {
        rate: fixedBottomBtnInfo?.rate || '0.00%',
      };
    },

    // 是否持仓 前后端都有
    isHold() {
      const { tradeData } = this;
      if (tradeData.length) {
        return tradeData?.[0]?.isHold || tradeData?.[1]?.isHold;
      }
      return false;
    },

    seatDesc() {
      const sellState = this.elementData?.sellState;
      if (isEmpty(sellState) || ![0, 4, 5].includes(sellState)) {
        return false;
      }
      const { availableSeat, showSeat } = this.productSeatsInfo;
      const { nextOpenDate } = this.mergeData || {};
      const now = new Date().getTime();
      const nextOpenDateTimestamp = new Date(
        nextOpenDate?.replace(/-/g, '/'),
      ).getTime();
      const isOverMonth = nextOpenDateTimestamp - now > 30 * 24 * 60 * 60 * 1000;
      // sellState=4/5 时：当前日期距离下一预约开始/开放日>1个月，不展示
      if ((sellState && isOverMonth) || !showSeat || !availableSeat) {
        return '';
      }
      return `${availableSeat < 100 ? `剩余${availableSeat}个` : '席位充足'}`;
    },

    btnConfig() {
      // sellState:0-可购；2-已售罄；3-可候补；4-即将开放；5-可预约；
      const { nextOpenDate } = this.mergeData || {};
      const sellState = this.elementData?.sellState;
      console.log('sellState', sellState);

      const date = isEmpty(nextOpenDate)
        ? '--'
        : dayjs(nextOpenDate).format('YYYY-MM-DD');

      // 没数据 加载状态
      if (!this.elementData || !Object.keys(this.elementData).length) {
        return [this.configBtn('数据加载中', 'fullDisabled', false)];
      }
      const leftBtn = this.configBtn('理财师', 'left', true, '', () => {
        const webPlatf = multi.$system.webPlatform;
        this.$wxSendTrack('wxgdpzy.gd.lcs.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
        if (webPlatf === 'wxmp') {
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({
            url: '/pages/business-card/general/index?sourceCode=lcs',
          });
        } else {
          this.$goFundApp();
        }
      });
      // 开放提醒（改成判断新的sellState=5）
      if (sellState === 5) {
        const tipText = `现在预约，${date}自动买入`;
        return [
          leftBtn,
          this.configBtn('预约购买', 'right', true, tipText),
        ];
      }
      // 售罄（改成判断新的sellstate=3）
      if (sellState === 3) {
        const tipText = '现在预约，有人退出后自动买入';
        return [
          leftBtn,
          this.configBtn('候补购买', 'right', true, tipText),
        ];
      }
      const buyStatus = this.getBuyStatus(sellState);
      console.log('buyStatus>>>', sellState);
      // 不可点击的状态(新的sellState=2)-不展示剩余席位
      if (buyStatus === '已售罄') {
        return [
          leftBtn,
          this.configBtn('已售罄', 'rightDisabled', false),
        ];
      }
      // 新的sellState=0/4
      // 可点击的状态 '购买', '开放提醒', '预约', '已设置提醒'
      return [
        leftBtn,
        this.configBtn(buyStatus, 'right', true),
      ];
    },
  },

  watch: {
    elementData: {
      handler() {
        setTimeout(() => {
          console.log('btnConfig', this.btnConfig);
        }, 2000);
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.initStatus(this.fundCode);

    // 初始化状态
    // multi.$on.backAppear(() => {
    //   if (this.fundCode) {
    //     this.initStatus(this.fundCode);
    //   }
    // });

    if (this.fundCode) {
      this.isShowRedPoint = false;
    }
  },

  methods: {
    formatNowDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();

      return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    },
    configBtn(text, img, canClick, tipText = '', clickEvent) {
      const imgConfig = {
        full: 'https://j5.dfcfw.com/sc/image/202202/20220209013530.png',
        fullDisabled: 'https://j5.dfcfw.com/sc/image/202110/20211025112126.png',
        left: 'https://j5.dfcfw.com/imagesystem/material_imgs/171996719179717.png',
        leftDisabled: 'https://j5.dfcfw.com/sc/image/202110/20211025113638.png',
        right: 'https://j5.dfcfw.com/imagesystem/material_imgs/1716271298587976.png',
        rightDisabled: 'https://j5.dfcfw.com/sc/image/202110/20211025113558.png',
      };
      return {
        text,
        img: imgConfig[img],
        canClick,
        tipText,
        btnBottomText: this.getOrderAlternateDesc(text),
        clickEvent,
      };
    },

    getOrderAlternateDesc(text) {
      console.log('getOrderAlternateDesc', text);
      if (!['预约购买', '候补购买', '购买'].includes(text)) {
        return '';
      }
      const isSetOrderBuy = text === '预约购买' || text === '购买';
      const {
        alternateCount, // 该用户创建的候补计划数量
        appointmentCount, // 该用户创建的预约计划数量
        alternateQueuePosition, // 用户位于候补队列位置，position从1开始，0代表不在队列中
        alternateQueueTotal, // 该产品候补队列总量
      } = this.productAlternateInfo || {};
      const isOrder = parseInt(alternateCount, 10) > 0 || parseInt(appointmentCount, 10) > 0;
      if (isOrder) {
        // 已预约
        return isSetOrderBuy
          ? `${appointmentCount ? `已设置${appointmentCount}笔` : ''}`
          : `${alternateQueuePosition ? `第${alternateQueuePosition}位` : ''}`;
      }
      // 未预约
      // 候补购买逻辑：已有其他用户候补：{已设置候补的用户数量，去重}位候补中；暂无其他用户候补：/
      // 预约购买逻辑：剩余席位<100，展示：剩余{剩余席位}个席位；剩余席位>=100，展示：席位充足
      return isSetOrderBuy
        ? this.seatDesc
        : `${alternateQueueTotal ? `${alternateQueueTotal}位候补中` : ''}`;
    },

    toHighEndTradeRule({ fundCode, fundName }) {
      tool.goDetail(`fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/gdlcIndex/index?fundCode=${fundCode}&fundName=${fundName}&index=1`, this.$goFundApp);
    },

    // 处理购买状态
    getBuyStatus(state) {
      // 3和5已特殊处理
      if (isEmpty(state)) {
        return '状态加载中';
      }
      try {
        return (
          {
            0: '购买', // 0-可购
            2: '已售罄', // 2-已售罄
            4: '即将开放', // 4-不展示购买，展示开放状态
          }[state] || '购买'
        );
      } catch (error) {
        return '购买';
      }
    },

    // // 获取风险测评
    // async getUserRiskMatchFund(fundCode) {
    //   if (this.$user && this.$user.uid) {
    //     const res = await tradeApiLvsApi.getUserRiskMatchFund({
    //       FundCode: fundCode,
    //       BType: '1',
    //     });
    //     this.riskInfo = res?.Data || {};
    //   }
    // },

    //  获取合格投资者和手签状态
    async getAuditAndSignResult(fundCode) {
      const info = window.highEndInfo || {};
      console.log('info>>>', info);
      if (info && info.uid) {
        const res = await getInvestorAuditResult({ fundCode });
        console.log('info', info, 'res?.Data>>>', res?.Data);
        this.auditAndSignInfo = res?.Data || {};
      }
    },

    // 初始化状态
    initStatus() {
      // 风险测评
      // this.getUserRiskMatchFund(fundCode);
      // // 合格投资者和手签状态
      this.getAuditAndSignResult(this.fundCode);
    },

    // 点击购买
    clickBuy(item) {
      console.log('tradeData>>', item);
      if (item.clickEvent) {
        item.clickEvent();
        return;
      }
      // 右边按钮点击
      const { canClick } = item;
      // 先判断当前状态是否可点击 售罄/数据加载中
      if (!canClick) {
        return;
      }
      console.log('clickBuy', item);
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        if (item.text === '购买') {
          this.$wxSendTrack('wxgdpzy.gd.gm.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5, location: 1 });
          const memoryInfo = {
            appId: 'funda4f4b61f03bd44',
            url: '/pages/purchase/index',
            params: {
              fundCode: this.fundCode,
            },
          };
          // 先判断是否合投 再跳签名
          // 签名需要传参
          // pfAuditState 和 pampAuditState分别表示私募基金和私募资管的验证状态，2就是成功
          // 私募资管认证情况-pampAuditState；私募基金认证情况-pfAuditState
          const status = this.auditAndSignInfo?.[this.mergeData?.isShowFundSize ? 'pfAuditState' : 'pampAuditState'];
          console.log('status>>>', status);
          let targetUrl = '';
          if (status !== 2) {
            //  合格投资者验证失败 跳转到合格投资者验证页面
            // 默认验证类型type: 'assetManage'资管， 'investFund'私募基金
            targetUrl = `https://tradeh5.tiantianfunds.cn/tradeh5/fundfeb1b95157ee5e/homeindex?type=${this.mergeData?.isShowFundSize ? 'assetManage' : 'investFund'}&fundCode=${this.fundCode}`;
          } else {
            targetUrl = `https://tradeh5.tiantianfunds.cn/tradeh5/08b356ea1c08322733c70601b9886520/signprotocolindex?fundCode=${this.fundCode}&tagPageData=${JSON.stringify(memoryInfo)}`;
          }
          console.log('targetUrl>>>', targetUrl);
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({
            url: `/pages/h5page/general?url=${encodeURIComponent(targetUrl)}&forceHash=1`,
          });
        } else {
          this.$wxSendTrack('wxgdpzy.gd.gm.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5, location: item.text === '预约购买' ? 2 : 3 });
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({
            url: `/pages/h5page/index?url=https://act.1234567.com.cn/topic/repository/fund-toapp-page/openmp.html?schema=fund://page/funddetail?fundcode=${this.fundCode}&id=${this.fundCode}&LinkType=1&AdId=0&IsVerifyLogin=false&CloseWeex=false`,
          });
        }
      } else {
        this.$wxSendTrack('wxgdpzy.gd.gm.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5, location: ['购买', '预约购买', '候补购买'].indexOf(item.text) + 1 });
        this.$goFundApp();
      }
    },
    // 点击讨论
    clickDiscuss() {
      this.$wxSendTrack('wxgdpzy.gd.tl.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      tool.goDetail(`fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarHomePage?fundCode=${this.fundCode}`, this.$goFundApp);
    },
  },
};
</script>

<style scoped>
.box {
  border-top: 1px solid #eeeeee;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2000;
}
.tip {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.row {
  display: flex;
  height: 48px;
  padding-left: 24px;
  padding-right: 40px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-top: 1px solid #eeeeee;
}

.text {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  text-align: center;
}

.text1 {
  color: #333333;
}

.text3 {
  margin-left: 10px;
  color: #333333;
}

.icon-text {
  margin-top: 8px;
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  line-height: 28px;
}

.right-arrow {
  /* px2wx:change next */
  width: 32px;
  height: 32px;
  margin-left: 2px;
}

.btns {
  display: flex;
  height: 100px;
  background-color: #fff;
  border-top: 1px solid #eee;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

}

.img1 {
  flex: 1;
  display: flex;
  margin-left: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-right: 4px;
  align-self: center;
}

.red-point {
  position: absolute;
  /* px2wx:change next */
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: #fa5914;
  top: 0;
  right: 0;
}

.img2,
.img3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.img {
  /* px2wx:change next */
  width: 42px;
  height: 42px;
}

.right {
  /* px2wx:change next */
  width: 400px;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-right: 40px;
}

.big-btn {
  display: flex;
  /* px2wx:change next */
  width: 310px;
  height: 80px;
  justify-content: center;
  align-items: center;
}

.btn-big-img {
  position: absolute;
  width: 310px;
  height: 80px;
}

.buy-text {
  /* line-height: 80px; */
  text-align: center;
  font-size: 32px;
  /* darkmode: off */
  color: #ffffff;
}

.two-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.left-btn {
  width: 192px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 40px 0 0 40px;
  position: relative;
  overflow: hidden;

}

.right-btn {
  width: 192px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0 40px 40px 0;
  position: relative;
  overflow: hidden;
}

.btn-text {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  /* darkmode: off */
  color: #ffffff;

}
.btn-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.btn-desc-text {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  /* darkmode: off */
  color: #ffffff;
}

.left-btn-img,
.right-btn-img {
  /* px2wx:change next */
  position: absolute;
  left: 0;
  width: 192px;
  top: 0;
  height: 80px;
  z-index: 1;
}

.icon {
  width: 24px;
  height: 24px;
}

.tip-box {
  bottom: 100px;
  right: 12px;
  justify-content: center;
  align-items: center;
}

.tip-text {
  border-radius: 12px;
  max-width: 400px;
  padding: 10px 24px;
  background: rgba(52, 55, 74, 0.96);
  font-family: PingFangSC-Regular;
  font-size: 28px;
  line-height: 42px;
  /* darkmode:off */
  color: #ffffff;
}

.arrow {
  width: 35px;
  height: 12px;
  transform: rotate(180deg);
}
</style>
